'use strict';
import {Button} from './button.js';
export class ButtonRevealPhoneNumber extends Button {
	
	constructor(component_key) {
		super(component_key);
		this.reveal = this.reveal.bind(this);
	}
	init() {
		super.init();
		this.reveal_after_login_flag = 'ral';
		this.call_after_login_flag = 'cal';
		this.add_events();
		if (yalwa.basics.ss_get(this.call_after_login_flag)) {
			this.call_after_login();
		}
		if (yalwa.basics.ss_get(this.reveal_after_login_flag)) {
			this.reveal_after_login();
		}
		if (this.$root.data('hide_phone_website_no_pa')) {
			this.$root.addClass('userprofile__phone_reveal--hidden_no_pa');
		}
	}
	/**
	 * @typedef {Object} TrackMap
	 * @property {function(): void} logged_in
	 * @property {function(): void} logged_out
	 */
	
	track(category) {
		/** @type {TrackMap} */
		const acc = {};
		['logged_in', 'logged_out'].forEach(action => {
			acc[action] = () => yalwa.basics.ga.event({
				category,
				action
			});
		});
		return acc;
	}
	reveal(call_button) {
		const csrf = this.$root.data('csrf');
		const data = {
			c: this.$root.data('code'),
			k: this.$root.data('key'),
			call_button: call_button ? 'vap_call' : 0,
		};
		
		return yalwa.basics.ajaxservice({
			type: 'POST',
			resource: 'posting',
			action: 'reveal_phone',
			csrf: csrf,
			identifier: yalwa.basics.get_msgID(null, true),
			data: data,
			include_session: true,
			is_cross_origin: true
		});
	}
	reveal_click_handler(event) {
        if (this.$root.data('hide_phone_website_no_pa')) {
			this.track('reveal_number').logged_in();
			// Dialog handler will open the dialog
            return;
        }
		// this request is not only for getting phone number but tracking, it should be called also for logged-out users.
		return this.reveal()
			.then( response => {
				if (yalwa.basics.is_logged_in()) {
					this.track('reveal_number').logged_in();
					if (response && response.success) {
						this.reveal_success_handler(response);
					}
				} else {
					this.track('reveal_number').logged_out();
					return yalwa.mobile.auth
						.register_success_handler(this.reveal_login_success_handler.bind(this))
						.show_dialog(event);
				}
			});
	}
	reveal_success_handler(response) {
		this.$label.html(response.number);
		this.$root.data('tel', response.number);
		this.$root.off('click.reveal').on('click.call', this.call_click_handler.bind(this));
	}
	
	call_success_handler(response) {
		this.$root.data('tel', response.number);
		this.call();
	}

	call() {
		const tel = `tel:${this.$root.data('tel')}`;
		yalwa.basics.navigate(tel);
		yalwa.basics.ga.ping_metric('CM_VAP_CALL', 1);
	}
	reveal_after_login() {
		yalwa.basics.ss_remove(this.reveal_after_login_flag);
		if (yalwa.basics.is_logged_in()) {
			this.reveal_click_handler();
		}
	}
	call_after_login() {
		yalwa.basics.ss_remove(this.call_after_login_flag);
		if (yalwa.basics.is_logged_in()) {
			this.call_click_handler();
		}
	}
	
	reveal_login_success_handler() {
		yalwa.basics.ss_set(this.reveal_after_login_flag, true);
		yalwa.basics.reload();
	}
	
	call_login_success_handler() {
		yalwa.basics.ss_set(this.call_after_login_flag, true);
		yalwa.basics.reload();
	}

	call_click_handler(event) {
        if (this.$root.data('hide_phone_website_no_pa')) {
			this.track('vap_call').logged_in();
			// Dialog handler will open the dialog
            return;
        }
		// this request is not only for getting phone number but tracking, it should be called also for logged-out users.
		return this.reveal(true)
			.then( response => {
				if (yalwa.basics.is_logged_in()) {
					this.track('vap_call').logged_in();
					if (response && response.success) {
						this.call_success_handler(response);
					}
				} else {
					this.track('vap_call').logged_out();
					return yalwa.mobile.auth
						.register_success_handler(this.call_login_success_handler.bind(this))
						.show_dialog(event);
				}
				
			});
	}

	add_events() {
		this.$root.off('click.reveal').on('click.reveal', this.reveal_click_handler.bind(this));
		jQuery('.js-vap_call_button').off('click.reveal_call').on('click.reveal_call', this.call_click_handler.bind(this));
	}
}